const DB_CONST = {
  PRODUCT_ID_TO_TYPE_NAME: {
    1: 'COMPLETE',
    6: 'COMPLETE',
    2: 'BASIC',
    7: 'BASIC',
    3: 'RESTRICT_FLAG',
    8: 'RESTRICT_FLAG',
    4: 'RESTRICT_DETAIL',
    9: 'RESTRICT_DETAIL',
    5: 'SCORE',
    10: 'SCORE'
  },

  PRODUCTS_TYPE: ['COMPLETE', 'BASIC', 'RESTRICT_FLAG', 'RESTRICT_DETAIL', 'SCORE'],
  PRODUCTS: {
    CPF_COMPLETE: 1,
    CPF_BASIC: 2,
    CPF_RESTRICT_FLAG: 3,
    CPF_RESTRICT_DETAIL: 4,
    CPF_SCORE: 5,
    CNPJ_COMPLETE: 6,
    CNPJ_BASIC: 7,
    CNPJ_RESTRICT_FLAG: 8,
    CNPJ_RESTRICT_DETAIL: 9,
    CNPJ_SCORE: 10,
  },
  // All Promotional Plans
  PROMOTIONAL_PLANS: [10, 11],

  // Constants to every single promotional plan
  FREE_CONSULTS_PROMOTIONAL_PLAN: 11,
  FREE_CONSULTS_PROMOTIONAL_PLAN_NUMBER: 5,
  
  FIRST_CONSULT_WITH_DISCOUNT_PROMOTIONAL_PLAN: 10,

  CHARGE_TYPES: {
    PAYMENT: 'PAYMENT',
    SUBSCRIPTION: 'SUBSCRIPTION'
  },

  // Filters
  FILTER_MODALS: {
    CREATE: 1,
    EDIT: 2,
    REMOVE: 3
  },

  // Notifications
  NOTIFICATION_TYPES: {
    INFO: 1,
    WARNING: 2,
    SYSTEM: 3
  },

  NOTIFICATION_TYPES_AUX: [
    {
      id: 3,
      type: 'system'
    },
    {
      id: 1,
      type: 'info'
    }
  ],

  NOTIFICATION_MODALS: {
    CREATE: 1,
    EDIT: 2,
    REMOVE: 3
  }

}

export default DB_CONST